import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export const ProjectCard = ({ project, index = 0 }) => {
  const { t } = useLanguage();
  return (
    <Reveal delay={(index % 3) * 0.08} className="break-inside-avoid">
      <Link to={`/projects/${project.slug}`} data-testid={`project-card-${project.slug}`} className="group mb-8 block">
        <div className="relative overflow-hidden rounded-2xl">
          <img
            src={project.images?.[0]}
            alt={`${project.name} — ${project.category} project in ${project.location}`}
            loading="lazy"
            className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/10 to-transparent" />
          <span className="absolute right-4 top-4 rounded-full bg-ink/70 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-white/85 backdrop-blur">
            {project.status}
          </span>
          <div className="absolute inset-x-0 bottom-0 p-6">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-gold">
              {project.location} · {project.category}
            </p>
            <h3 className="mt-1 font-display text-2xl text-offwhite">{project.name}</h3>
          </div>
          <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-gold transition-[width] duration-500 group-hover:w-full" />
        </div>
        <div className="mt-3 flex items-center justify-between text-xs">
          <span className="text-charcoal/55">{[project.floors, project.completion_year].filter(Boolean).join(" · ")}</span>
          <span className="inline-flex items-center gap-1 font-bold uppercase tracking-wider text-gold-dark">
            {t("projects.viewCase")}
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
};
